import { Messages } from '../../config';
import { ENDPOINT_CLIENT_EMAIL_CAMPAIGNS } from '../../config/endpoints';
import { getAxios } from '../axios';
import {
  getTokenHeaders,
  errorCatch, getNotificationId,
  addParam
} from '../helper';
import { store } from "../../store/store";
import { NOTIFICATION_SUCCESS } from "../../store/actions/types";
import { HTTP_CREATED, HTTP_OK } from '../../config/constants/requestsStatuses';
import { showGlobalNotification } from '../../store/actions/globalNotification';

/**
 * Create a email campaign
 * @param {object} payload
 * @param {string} payload.notificationId
 * @param {object} payload.data
 * @param {string} payload.data.template
 * @param {string} payload.data.recipients
 * @returns {Promise<T>}
 */
export function createEmailCampaign(payload) {
  return getAxios().post(
    addParam(
      ENDPOINT_CLIENT_EMAIL_CAMPAIGNS,
      {
        "{emailCampaign}": "",
      }
    ),
    payload.data,
    getTokenHeaders()
  ).then(
    response => {
      if (response && response.status === HTTP_CREATED) {
        store.dispatch(showGlobalNotification(NOTIFICATION_SUCCESS, Messages.CREATE_RESOURCE_SUCCESS));
        return response;
      }

      return null;
    }
  ).catch(
    e => {
      errorCatch(e, {
        400: 'concat',
        401: Messages.UNAUTHENTICATED_ERROR,
        403: Messages.UNAUTHORIZED_ERROR,
        404: Messages.NOT_FOUND_ERROR,
      }, getNotificationId(payload));

      return e.response;
    }
  );
}

/**
 * Get list of email campaigns
 * @param {object} payload
 * @param {boolean} [payload.disablePagination]
 * @param {boolean} payload.hideNotification
 * @param {object} payload.pagination
 * @param {number} payload.pagination.page
 * @param {number} payload.pagination.per_page
 * @param {string} payload.pagination.sort_by
 * @param {string} payload.pagination.sort
 * @param {string} payload.pagination.q
 * @returns {Promise<T>}
 */
export function getEmailCampaigns(payload) {
  if (payload && payload.disablePagination === true) {
    if (!payload.pagination) {
      payload.pagination = {};
    }

    payload.pagination.per_page = 100000;
  }

  return getAxios(payload.hideNotification).get(
    addParam(
      ENDPOINT_CLIENT_EMAIL_CAMPAIGNS,
      {
        '{emailCampaign}': '',
      }
    ),
    getTokenHeaders(payload.pagination || null)
  )
    .then(response => {
      return response && response.data ? response.data : null
    })
    .catch(
      e => {
        errorCatch(e, {
          400: 'concat',
          401: Messages.UNAUTHENTICATED_ERROR,
          403: Messages.UNAUTHORIZED_ERROR,
          404: Messages.NOT_FOUND_ERROR,
        });

        return e.response;
      }
    );
}

/**
 * Send a email campaign
 * @param {object} payload
 * @param {string} payload.notificationId
 * @param {object} payload.data
 * @param {string} payload.data.id
 * @returns {Promise<T>}
 */
export function sendEmailCampaign(payload) {
  return getAxios().post(
    addParam(
      ENDPOINT_CLIENT_EMAIL_CAMPAIGNS,
      {
        "{emailCampaign}": payload.data.id,
      }
    ),
    payload.data,
    getTokenHeaders()
  ).then(
    response => {
      if (response && response.status === HTTP_OK) {
        store.dispatch(showGlobalNotification(NOTIFICATION_SUCCESS, Messages.SEND_EMAIL_CAMPAIGN_SUCCESS));
        return response;
      }

      return null;
    }
  ).catch(
    e => {
      errorCatch(e, {
        400: 'concat',
        401: Messages.UNAUTHENTICATED_ERROR,
        403: Messages.UNAUTHORIZED_ERROR,
        404: Messages.NOT_FOUND_ERROR,
      }, getNotificationId(payload));

      return e.response;
    }
  );
}

/**
 * Get details of email campaign
 * @param {object} payload
 * @param {string} payload.notificationId
 * @param {object} payload.data
 * @param {string} payload.data.emailCampaignId
 * @param {object} payload.pagination
 * @param {string} payload.pagination.page_context
 * @returns {Promise<T>}
 */
export function getEmailCampaignDetails(payload) {
  return getAxios()
    .get(
      addParam( ENDPOINT_CLIENT_EMAIL_CAMPAIGNS, {
        "{emailCampaign}": payload.data.emailCampaignId,
      } ),
      getTokenHeaders(payload.pagination)
    )
    .then( (response) => {

      return response && response.data ? response.data : null;

    } )
    .catch( (e) => {
      errorCatch( e, {
        400: 'concat',
        401: Messages.UNAUTHENTICATED_ERROR,
        403: Messages.UNAUTHORIZED_ERROR,
        404: Messages.NOT_FOUND_ERROR,
      }, getNotificationId( payload ) );

      return e.response;
    } );
}
